import type { AxiosRequestConfig, Canceler } from 'axios'
import axios from 'axios'
import { isFunc } from '@/utils/is'
import qs from 'qs'

let pendingMap = new Map<string, Canceler>()
function generateCacheKey(config: AxiosRequestConfig): string {
  const { method, url, params, data } = config // 请求方式，参数，请求地址，
  let cacheKey = ''
  try {
    cacheKey = typeof data === 'object' ? data : JSON.parse(data)
  } catch (error) {
    /* empty */
  }
  return [method, url, qs.stringify(params), qs.stringify(cacheKey)].join('&').replace(/&+$/, '') // 拼接
}
export const getPendingUrl = (config: AxiosRequestConfig) => generateCacheKey(config)

export class AxiosCanceler {
  /**
   * Add request
   * @param {Object} config
   */
  addPending(config: AxiosRequestConfig) {
    this.removePending(config)
    const url = getPendingUrl(config)
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken(cancel => {
        if (!pendingMap.has(url)) {
          pendingMap.set(url, cancel)
        }
      })
  }

  /**
   * 路由跳转的时候移除所有pending
   */
  removeAllPending() {
    pendingMap.forEach(cancel => {
      cancel && isFunc(cancel) && cancel()
    })
    pendingMap.clear()
  }

  /**
   * Removal request
   * @param {Object} config
   */
  removePending(config: AxiosRequestConfig) {
    const url = getPendingUrl(config)

    if (pendingMap.has(url)) {
      const cancel = pendingMap.get(url)
      cancel && cancel(url)
      pendingMap.delete(url)
    }
  }

  /**
   * @description: reset
   */
  reset(): void {
    pendingMap = new Map<string, Canceler>()
  }
}
